(ns hypnos.sleeplab.tile.field.consult-service-type
  "Field for the consult service type."
  (:require [clojure.string :as str]
            [hypnos.i18n :refer [tr]]))

;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;
;;; Field

(defn field
  ([state]
   (field state {:disabled false}))
  ([state {:keys [disabled] :or {disabled false}}]
   [:div.field.is-horizontal
    [:div.field-label.is-normal
     [:label.label (tr :ui.label/service-type)]]
    [:div.field-body
     [:div.field.is-narrow
      [:div.control
       [:div.select.is-fullwidth
        [:select
         {:type      :text
          :disabled  disabled
          :value     (name (get-in @state [:patient :patient/last-consult :consult/service-type :value]))
          :on-change (fn [e]
                       (let [old-value (get-in @state [:patient :patient/last-consult :consult/service-type :value])
                             new-value (when-not (str/blank? (-> e .-target .-value))
                                         (keyword (str "service-type/" (-> e .-target .-value))))
                             changed?  (or (get-in @state [:patient :patient/last-consult :consult/service-type :dirty?])
                                           (not= new-value old-value))]
                         (swap! state assoc-in
                                [:patient :patient/last-consult :consult/service-type :value]
                                new-value)
                         (swap! state assoc-in
                                [:patient :patient/last-consult :consult/service-type :dirty?]
                                changed?)))
          :on-focus  (fn [_]
                       (swap! state assoc-in
                              [:patient :patient/last-consult :consult/service-type :touched?]
                              true))}
         [:option {:key "sleep-study" :value "sleep-study"} (tr :ui.service-type/sleep-study)]
         [:option {:key "home-study" :value "home-study"} (tr :ui.service-type/home-study)]]]]
      (when-not disabled [:p.help (tr :ui.help/service-type)])]]]))
